<template>
  <v-card flat>
  <v-card-title class="subheader py-0">
    <v-icon small class="mr-1" color="teal">group</v-icon>
    已提交申报的项目
    <v-spacer/>
    <v-btn flat round color="primary" dark
           :disabled = viewDeclareDisna
      @click="mark = true"
    >
      <v-icon>dialpad</v-icon>
      查看评审结果
    </v-btn>
    <v-btn flat round color="primary" dark
           :disabled = exportDeclareDisna
           :href="excelUrl">
      <v-icon>folder_open</v-icon>
      导出申报项目清单
    </v-btn>
  </v-card-title>

    <v-card-text class="pt-0">
      <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-0 dense"
          no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1 }}</td>
          <td class="">{{ props.item.reviewProj.name }}</td>
          <td class="">{{ props.item.type.name }}</td>
          <td class="">{{ props.item.reviewProj.leaderName }}</td>
          <td class="">{{ props.item.subject.name }}</td>
          <td class="">{{ props.item.department.name }}</td>
          <td class="">{{ props.item.reviewProj.leaderPhone }}</td>

        </template>
      </v-data-table>
    </v-card-text>

    <ReviewResult
        v-model= "mark"
        :mark = "mark"
        :review-id = "reviewId"
        :decproj = "decProj"
        @ok="onReturn"
    >
    </ReviewResult>

  </v-card>

</template>

<script>

import ReviewResult from "@/components/proj/review/ReviewResult";
const baseUri = '/api/proj/review';
export default {
  name: "DeclareProj",
  components:{ReviewResult},
  props:['reviewId'],
  data: () => ({

    items: [],

    mark: false,

    form: {
      reviewId: '',
    },

    viewDeclareDisna: false,
    exportDeclareDisna: false,

    decProj: [],

    headers: [
      {text: '#', sortable: false, value: 'rank', width: 18},
      {text: '项目名称', value: 'name', sortable: false},
      {text: '项目类别', value: 'type', sortable: false},
      {text: '负责人', value: 'leader', sortable: false},
      {text: '学科', value: 'subject', sortable: false},
      {text: '归属部门', value: 'department', sortable: false},
      {text: '联系电话', value: 'phone', sortable: false},
    ],
  }),
  watch: {
    reviewId(reviewId) {
      window.console.log("项目申报模块")
      window.console.log(reviewId)
      window.console.log(reviewId.status.identifier)
      if(reviewId.status.identifier === "unpub" || reviewId.status.identifier === "pubed")
      {
        //如果申报处于未发布、发布状态，则导出清单、查看评审结果功能不可用
        this.viewDeclareDisna = true
        this.exportDeclareDisna = true

      }
      else {
        //只有申报状态为评审结束，方可查看评审结果
        if(reviewId.status.identifier != "finish")
          this.viewDeclareDisna = true
        let t = "dec"
        this.axios
            .get(`${baseUri}/${t}/${reviewId.dbid}`)
            .then(rsp => {
              if (rsp.status == 200 && rsp.data.items.length > 0) {
                this.items = rsp.data.items
                this.decProj = this.items
                this.exportDeclareDisna = false
              }
              else {
                this.exportDeclareDisna = true
              }
            })
      }
    }
  },

  computed: {
    excelUrl() {
      const vm = this
      // window.console.log(this.form);
      const url = '/api/proj/review/exp/fmt/excel';
      //let t = "exp/fmt/excel"
      //const url = `${baseUri}/${t}/${this.reviewId}`
      vm.form.reviewId = vm.reviewId.dbid
      return window.xutil.buildUrl(url, Object.assign({limit: 2000}, vm.form))
    },

  },

  methods: {
    onReturn() {
      this.mark = false
    }
  }


}
</script>

<style scoped>

</style>